import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from '@angular/router';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RequestGuard implements CanActivate {

  constructor(private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    if (sessionStorage.getItem('REQUEST')) {
      return true;
    } else {
      if (sessionStorage.getItem('TOKEN')) {
        this.router.navigateByUrl('profile');
      } else {
        this.router.navigateByUrl('login');
      }
    }
    return false;
  }
  
}
